/**
 * Attach an event listener to the document that triggers a callback when a click occurs outside of a specified node.
 *
 * @param {HTMLElement} node - The node to monitor for outside clicks.
 * @param {Function} onOutsideClick - The callback to trigger when an outside click occurs.
 * @returns {Object} An object with a destroy method that removes the event listener.
 */
export default function clickOutside(node, onOutsideClick) {
  function handleClick(event) {
    if (node && !node.contains(event.target) && !event.defaultPrevented) {
      onOutsideClick();
    }
  }

  document.addEventListener('click', handleClick, true);

  return {
    destroy: function () {
      document.removeEventListener('click', handleClick, true);
    }
  };
}